import React from 'react'
import Loader from 'react-loader-spinner'
import {Button, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import {pageHelpers} from '../pages/'

class AddUserModal extends React.Component {
    constructor(props) {
        super(props)
        const {close, submit, className, teamName} = props
        pageHelpers.setupSingleRunAnimationEvents()

        this.submit = submit
        this.className = className
        this.close = close
        this.state = {
            teamName,
            email: '',
            loading: false,
            requestError: false,
            submitted: false,
        }

        this.handleValidSubmit = this.handleValidSubmit.bind(this)
        this.handleInvalidSubmit = this.handleInvalidSubmit.bind(this)
    }

    componentWillUnmount() {
        pageHelpers.tearDownSingleRunAnimationEvents()
    }

    componentWillReceiveProps(nextProps) {
        const {close, submit, className, teamName} = nextProps
        this.submit = submit
        this.className = className
        this.close = close
        this.setState({teamName})
    }

    async handleValidSubmit(event, values) {
        event.preventDefault()
        let {email} = values
        this.setState({loading: true})
        try {
            let result = await this.submit(email)
            if (result.errors && result.errors.length) {
                let requestError = result.errors[0]
                this.setState({loading: false, errorFields: [], requestError, email})
            } else {
                this.setState({loading: false, submitted: true, errorFields: [], email})
            }
        } catch (error) {
            console.log(error)
            this.setState({loading: false, errorFields: [], requestError: [error.message], email})
        }
    }

    handleInvalidSubmit(e, errors) {
        this.setState({errorFields: errors})
    }

    render() {
        let {loading, requestError, submitted, teamName, email} = this.state
        return (loading ?
            <Modal isOpen={true}
                   toggle={this.close}
                   className={this.className}>
                <ModalHeader toggle={this.close}>
                    Inviting User...
                </ModalHeader>
                <ModalBody className="text-center">
                    <Loader type="TailSpin" color="orange" width={60} height={60}/>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal> :
            (requestError ?
                <Modal isOpen={true}
                       toggle={this.close}
                       className={this.className}>
                    <ModalHeader toggle={this.close}>
                        Error
                    </ModalHeader>
                    <ModalBody className="text-center">
                        <p>Sorry! There was an error inviting this user.</p>
                        <br/>
                        <p>Please try again in a few minutes or contact support if the issue persists.</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary"
                                onClick={this.close}>
                            Done
                        </Button>
                    </ModalFooter>
                </Modal> :
                (submitted ?
                    <Modal isOpen={true}
                           toggle={this.close}
                           className={this.className}>
                        <ModalHeader toggle={this.close}>
                            Invite User To Team
                        </ModalHeader>
                        <ModalBody className="text-center">
                            <p>
                                {email} has been invited to join your team.
                            </p>
                            <br/>
                            <p>
                                They should receive an email invitation to setup their account soon.
                            </p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.close}>Done</Button>
                        </ModalFooter>
                    </Modal> :
                    <Modal isOpen={true}
                           toggle={this.close}
                           className={this.className}>
                        <AvForm className="p-0 m-0"
                                onValidSubmit={this.handleValidSubmit}
                                onInvalidSubmit={this.handleInvalidSubmit}>
                            <ModalHeader toggle={this.close}>
                                Invite User To Team
                            </ModalHeader>
                            <ModalBody className="">
                                Please enter the email address of the person you would like to invite
                                to join <strong>{teamName}</strong>.
                                <AvGroup className="text-left mb-2 mt-2">
                                    <Label>
                                        Email Address
                                    </Label>
                                    <AvInput name="email"
                                             placeholder="newuser@email.com"
                                             type="email"
                                             required/>
                                    <AvFeedback>
                                        Please enter a valid email address.
                                    </AvFeedback>
                                </AvGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.close}>
                                    Cancel
                                </Button>
                                <Button className="bg-light-sf-blue">
                                    Invite User
                                </Button>
                            </ModalFooter>
                        </AvForm>
                    </Modal>)))
    }
}

export default AddUserModal



// WEBPACK FOOTER //
// ./src/components/ui/AddUserModal.js